import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-inverter",
  "use": "dv-inverter-usage",
  "viewBox": "0 0 16.66 20",
  "content": "<symbol viewBox=\"0 0 16.66 20\" id=\"dv-inverter\"><title>dv-inverter</title><path d=\"M17.44,1.87H14V.8a.8.8,0,1,0-1.6,0V1.87H7.6V.8A.8.8,0,1,0,6,.8V1.87H2.56a.88.88,0,0,0-.88.88V19.12a.88.88,0,0,0,.88.88H17.44a.88.88,0,0,0,.88-.88V2.75A.88.88,0,0,0,17.44,1.87ZM10,18.67a.66.66,0,1,1,.66-.66A.66.66,0,0,1,10,18.67ZM15.9,8.5a.85.85,0,0,1-.85.85H4.95A.85.85,0,0,1,4.1,8.5V5.33a.85.85,0,0,1,.85-.85h10.1a.85.85,0,0,1,.85.85Z\" transform=\"translate(-1.67)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-inverter.svg
// module id = q/uf
// module chunks = 264